import React, { Fragment } from 'react';
import { DeviceType } from 'contexts/device';
import classNames from 'classnames/bind';
import { TripType } from 'contexts/searchParams';
import styles from './chartBar.module.scss';
import { getPriceToolTip, IChartBarData } from 'common/modal/chart/utilChart';

const cx = classNames.bind(styles);

const toolTipBoxDefaultX = 65;
const arrowDefaultX = 20;
interface IPriceBoxProps {
  device: DeviceType;
  trip: TripType;
  barTotalWidth: number;
  mouseOverItem: IChartBarData | null;
  selectedBarItem: IChartBarData | undefined | null;
  selectedBarOrderIndex: number;
  barDataList: IChartBarData[];
  pcToolTipBoxLimitIndex: number;
}

const PriceBox = (props: IPriceBoxProps) => {
  const {
    device,
    trip,
    mouseOverItem,
    selectedBarItem,
    selectedBarOrderIndex,
    barDataList,
    barTotalWidth,
    pcToolTipBoxLimitIndex,
  } = props;

  return (
    <>
      {/* 모바일 */}
      {device === DeviceType.MOBILE && (
        <div className={cx('tooltip')}>
          <i
            className={cx('tip')}
            style={{ marginLeft: `${arrowDefaultX}px` }}
          />
          {getPriceToolTip(
            trip,
            barDataList?.[2] || { state: -1, price: null },
            true,
          )}
        </div>
      )}

      {/* pc */}
      {device === DeviceType.PC &&
        (mouseOverItem || selectedBarOrderIndex > -1) && (
          <div
            className={cx('tooltip')}
            style={{
              width: '136px',
              marginLeft: `${
                (selectedBarOrderIndex > pcToolTipBoxLimitIndex
                  ? pcToolTipBoxLimitIndex
                  : selectedBarOrderIndex) *
                  barTotalWidth +
                toolTipBoxDefaultX
              }px`,
            }}
          >
            <i
              className={cx('tip')}
              style={{
                marginLeft: `${
                  selectedBarOrderIndex > pcToolTipBoxLimitIndex
                    ? (selectedBarOrderIndex - pcToolTipBoxLimitIndex) *
                        barTotalWidth +
                      arrowDefaultX
                    : arrowDefaultX
                }px`,
              }}
            />
            {getPriceToolTip(trip, mouseOverItem || selectedBarItem, true)}
          </div>
        )}
    </>
  );
};

export default PriceBox;
